import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';

import {Subscription} from 'rxjs';

import {EntitiesComponent} from '../../../entities.component';

import {LoginService} from '../../../../pages/login/login.service';
import {AppService, UserService} from '../../../../shared/service/user.service';
import {AuthService} from '../../../../shared/service/auth.service';
import {ItemsService} from '../../../personal-income-tax/root-info';
import {AppSubject} from '../../../../shared/app-subject';
import {Severity, ToastService} from '../../../../shared/components/toast/toast.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html'
})
export class TopbarComponent implements OnInit, OnDestroy {

  @Input() activeModule?: string;

  AuthService = AuthService;

  user: any;
  displayName?: string;

  decreeAndCircularUsing?: string;

  changingPassword?: boolean;
  submittedPassword?: boolean;
  changePasswordForm = this.fb.group({
    oldPassword: ['', Validators.required],
    newPassword: ['', Validators.required],
    newPasswordVerify: ['', Validators.required]
  });
  changePasswordError?: string;

  decreeCircularSubscription?: Subscription;

  logoData: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public entities: EntitiesComponent,
    private loginService: LoginService,
    private toastService: ToastService,
    private infoService: ItemsService
  ) {
  }

  ngOnInit(): void {

    this.logoData = UserService.get('user-logo');

    this.user = UserService.getUser();
    this.infoService.get().subscribe((listData :any)=>{
      if (listData.partyTaxId){
        AppService.set('PARTY_TAX_ID', listData.partyTaxId);
        this.displayName = listData.partyTaxId;
      }else {
        this.displayName = this.user.partyName;
      }
    })
    this.decreeCircularSubscription = AppSubject.getDecreeCircular().subscribe((decreeCircular) => {
      this.decreeAndCircularUsing = decreeCircular;
    });
    // if (AuthService.hasRoles(['Customer'])) {
    //   this.displayName = this.user.partyTaxId;
    // } else {
    //   this.displayName = this.user.partyName;
    // }
    if (AuthService.hasRoles(['Administrator'])){
      this.displayName = this.user.partyName
    }
  }

  ngOnDestroy(): void {
    if (this.decreeCircularSubscription) {
      this.decreeCircularSubscription.unsubscribe();
    }
  }

  changePassword(): void {
    this.changePasswordForm.reset();
    this.changingPassword = true;
  }

  onChangePassword(): void {
    if (!this.submittedPassword && this.changePasswordForm.valid) {
      this.submittedPassword = true;
      this.changePasswordError = '';

      this.loginService.changePassword(this.changePasswordForm.value).subscribe(({isSuccess, messages}) => {
        this.submittedPassword = false;
        if (isSuccess === 'Y') {
          this.toastService.setMessage({severity: Severity.SUCCESS, detail: messages});
          this.changingPassword = false;
        } else {
          this.changePasswordError = messages;
        }
      }, () => {
        this.submittedPassword = false;
      });
    }
  }

  logout(): void {
    this.loginService.logout().subscribe(() => {
      this.router.navigateByUrl('/login').then();
    });
  }

}
